import type { Content, Heading } from 'mdast';
import {
  type PerspectiveCategory,
  getPerspectiveCategoryFromTitle,
} from './perspectiveTabContext';

type HeadingChild = Heading['children'][number];
type TextNode = Content | HeadingChild;

export type PerspectiveTab = {
  category: PerspectiveCategory;
  subtitle?: string;
  content: Content[];
};

const tabCategoryOrder: PerspectiveCategory[] = ['mainScenario', 'public', 'insider'];

const getTextFromNode = (node: TextNode): string => {
  if (node.type === 'text') {
    return node.value;
  }
  if (("children" in node) && node.children && Array.isArray(node.children)) {
    return node.children.map(child => getTextFromNode(child)).join(' ');
  }
  return '';
};

export const getPerspectiveTabs = (children: Content[]): PerspectiveTab[] => {
  const tabs: PerspectiveTab[] = [];
  let currentTab: PerspectiveTab | null = null;

  children.forEach((node) => {
    if (node.type === 'heading' && (node as Heading).depth === 2) {
      if (currentTab) {
        tabs.push(currentTab);
      }
      const heading = node as Heading;
      const title = heading.children.map(getTextFromNode).join(' ');
      currentTab = {
        category: getPerspectiveCategoryFromTitle(title),
        content: [],
      };
    } else if (currentTab) {
      currentTab.content.push(node);
    }
  });
  if (currentTab) {
    tabs.push(currentTab);
  }

  const tabsWithSubtitles = tabs.map((tab) => {
    const firstNode = tab.content[0];
    if (firstNode && firstNode.type === 'heading' && (firstNode as Heading).depth === 3) {
      return {
        ...tab,
        subtitle: (firstNode as Heading).children.map(getTextFromNode).join(' '),
        content: tab.content.slice(1),
      };
    }
    return tab;
  });

  return tabCategoryOrder
    .flatMap(category => tabsWithSubtitles.filter(tab => tab.category === category));
};
